/**
 * Created by RKL on 07/09/2015.
 */
define('adminKitlDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminKitlDetailsTpl',
  'adminKitlTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  kitlsTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var KitlsDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.kitl-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    // events: {
    //   'change @ui.collectionToggle': 'onCollectionToggle'
    // },

    regions: {
      kitlDetailTab: '#detail-tab'
    },

    behaviors: function() {
      var redirectUrl = 'admin/kits/'+this.options.model.get('refKit').secId+'/kitl';
      return {
        BackToList: {
          behaviorClass: BackToListBehavior,
          redirectUrl: redirectUrl
        }
      };
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.kitlsTabs = kitlsTabs;
      templateData.compulogoCollection = this.model.get('compulogoCollection');
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.kitl-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    }
  });

  module.exports = KitlsDetailsView;
});
